export enum BulkUpdateMethod {
  set = 'SET',
  unset = 'UNSET',
  push = 'PUSH',
  pull = 'PULL',
  refresh = 'REFRESH',
}

export type BulkUpdateMethodType = 'SET' | 'UNSET' | 'PUSH' | 'PULL' | 'REFRESH'
